// extracted by mini-css-extract-plugin
module.exports = {"routePageCol":"Route_routePageCol__3OXqP"};